import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "../home/home.css";
import "../callforpaper/callforpaper.css";
import "./register.css";
import registerCompletedSteps from "./registerCompletedSteps.json";
import registerFees from "./registerFees.json";
import ExamplePdf from "./agreement.docx";
import "../button/button.css";

class Register extends Component {
  render() {
    return (
      <>
        <div className="header-area">
          <div id="home" className="contact-header-area  bg_cover">
            <Navbar />
            <div className=" d-flex align-items-center">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="header-content text-center">
                      <h2 className="header-title2">REGISTRATION</h2>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="schedule-section row">
          <table className="annoucement-table container">
            <tr className="annoucement-table-header-row">
              <th>Category of Delegates</th>
              <th>
                Registration Fee <br />
              </th>
              <th>
                Late Fee <br />
              </th>
            </tr>
            {registerFees &&
              registerFees.map((a, key) => (
                <tr className="announcement-table-row">
                  <td className="annoucement-title">{a?.title}</td>
                  <td dangerouslySetInnerHTML={{ __html: a?.fee }} />
                  <td dangerouslySetInnerHTML={{ __html: a?.latefee }} />
                </tr>
              ))}

          </table>

        </div>


        <div className="container">
          <h1 style={{
            fontSize: "20px"
          }}>
          Manuscript SHOULD have a Minimum of 10 pages, and a Maximum of 14 pages.
           <br />
          However, up to 2 extra pages over the Maximum limit of 14 pages may be considered with additional page charges (Rs. 500/page)
          </h1>
          <br />
          <div>
            <h1
              style={{
                fontSize: "24px",
                color: "#1662FD"
              }}
            >
              Account Details:
            </h1>
            <h1
              style={{
                fontSize: "18px",

              }}
            >
              K C COLLEGE OF ENGINEERING , CONFERENCES
              <br />
              Punjab National Bank
              <br />
              A/c No. 3303000110153121
              <br />
              Thane (East) Mah 400603 Branch
              <br />
              IFSC Code : PUNB0330300
            </h1>
            <br />
            <h1
              style={{
                fontSize: "20px",
              }}
            >
              After registration, send the signed copyright aggreement and proof to payment to the following mail id:
            </h1>

            <a
              href="mailto:icishmc2022@kccemsr.edu.in"
              className="info-title-email"
            >
              icishmc2022@kccemsr.edu.in{" "}
            </a>
            <br />

            <h1
              style={{
                fontSize: "20px",
                color:"#000000"
              }}
            >
             Acceptance / Rejection notifications for the papers have been sent via E-mail (to the corresponding authors)
            </h1>

          </div>
          <br />
          <div
            style={{
              marginBottom: "5px"
            }}
          >
            <a href={ExamplePdf} download="Copyright Agreement" target="_blank">
              <button class="main-btn main-btn-2">Copyright Agreement</button>
            </a>
          </div>


        </div>



        {/* <div className="container callforpapertext-instruction">
					<p className="callforpapertext-title-semi">Registration Guidelines</p>
					<p className="callforpapertext-2 ">
						Once your paper is accepted the registration process begins. You
						must complete the following four steps:
						<ol>
							{registerCompletedSteps &&
								registerCompletedSteps.map((a, key) => (
									<li className="callforpaperlist">{a}</li>
								))}
						</ol>
					</p>
				</div> */}

        {/* <div className="container register-main-text">
					<p className="callforpapertext-title-semi">
						CONFERENCE FEE DOES NOT INCLUDE TRANSPORTATION AND ACCOMMODATION
						CHARGES.
					</p>
				</div> */}
        {/* <div className="container register-main-text">
					<p className="callforpapertext-title-semi">
						<u>
							Students have to send copy of their Institute's Id-Card along with
							the registration form.
						</u>
					</p>
				</div>
				<div className="container register-main-text last-text">
					<p className="callforpapertext-title-semi">
						At least one author must register as delegate with full registration
						fee applicable as above for inclusion of paper in the proceedings.
						Single author with multiple papers has to register separately for
						each paper.
					</p>
				</div> */}
        {/* <h1 className="text-center" style={{ margin: "50px 0" }}>
					COMING SOON..
				</h1> */}
      </>
    );
  }
}

export default Register;
